// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__w7Kk7","header":"ReportDetails_header__4zJRT","title":"ReportDetails_title__3HBui","left":"ReportDetails_left__Uu7IZ"};